<template>
    <div class="person-header">
        <div class="header">
            <div class="header-bg">
                <h1 class="header-title">个人中心</h1>
            </div>
        </div>
        
        <div class="main-content">
            <div class="nav-tabs">
                <router-link 
                    to="/read/myBookshelf"
                    class="tab-item"
                    :class="{ active: $route.path === '/read/myBookshelf' }"
                >
                    我的书架
                </router-link>
                <router-link 
                    to="/read/studyReport"
                    class="tab-item"
                    :class="{ active: $route.path === '/read/studyReport' }"
                >
                    学习报告
                </router-link>
            </div>
            
            <div class="content-area">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PersonHeader'
}
</script>

<style scoped lang="scss">
.person-header {
    // min-height: 100vh;
    background-color: #f5f5f5;

    .header {
        position: relative;
        height: 180px;
        overflow: hidden;
        background: #404245;

        .header-bg {
            max-width: 1200px;
            margin: 0 auto 40px;
            padding: 80px 20px;

            .header-title {
                color: white;
                font-size: 32px;
                font-weight: bold;
                text-align: left;
                position: relative;
                
                &::after {
                    content: "";
                    position: absolute;
                    bottom: 0px;
                    left: 0;
                    height: 1px;
                    width: 8em;
                    background-color: #fff;
                    border-radius: 10px;
                }
            }

        }
        
    }

    .main-content {
        max-width: 1200px;
        margin: 0 auto 40px;
        padding: 20px;
    }

    .nav-tabs {
        display: flex;
        margin-bottom: 15px;
    }

    .tab-item {
        padding: 15px;
        cursor: pointer;
        font-size: 18px;
        color: #000;
        position: relative;
        transition: all 0.3s ease;
        text-decoration: none;
        display: block;

        &:hover {
            color: #D82A1E;
            text-decoration: none;
        }

        &.active {
            font-weight: bold;

            &::after {
                content: "";
                position: absolute;
                bottom: 10px;
                left: 37%;
                /* right: 50%; */
                height: 3px;
                width: 2em;
                background-color: #D82A1E;
            }
        }
    }

    .content-area {
        min-height: 400px;
        // background-color: white;
        // border-radius: 10px;
        // box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
        // padding: 20px 30px;
    }
}
</style> 